import { apiInterfaceForJson } from '../common/apiManager';

export const fetchInstruments = () => {
    return apiInterfaceForJson('/instrument/v1/', 'GET');
};

export const getInstrumentDataById = (instrumentId) => {
    return apiInterfaceForJson('/instrument/v1/' + instrumentId, 'GET');
};

export const createInstrument = (instrumentDetails) => {
    return apiInterfaceForJson('/instrument/v1/', 'POST', instrumentDetails);
};

export const updateInstrument = (instrumentDetails) => {
    return apiInterfaceForJson('/instrument/v1/', 'PUT', instrumentDetails);
};

export const deleteInstrument = (instrumentDetails) => {
    return apiInterfaceForJson('/instrument/v1/delete', 'POST', instrumentDetails);
};
